<template>
    <div class="col-12">
        <div class="row">
            <div class="col product-row">
                <div class="d-flex flex-row product-info" v-if="$root.mobile === false">
                    <div class="col-3 px-0 text-center product-image d-desktop-only">
                        <a :href="product.link" :title="product.name"> <img :src="product.thumbnail" :alt="product.name"> </a>
                    </div>
                    <div class="col-6 px-0 text-left flex-fill product-title-block">
                        <div class="row h-25">
                            <div class="col-12 product-title">
                                <a :href="product.link" :title="product.name"> <span>{{ product.name.length > 20 ? product.name.substring(0, 20).trim() + '...' : product.name }}</span></a>
                            </div>
                        </div>
                        <div class="row h-25">
                            <div class="col-12 product-variant">
                                {{ product.attributes }}
                            </div>
                        </div>
                        <div class="row h-50 d-desktop-only">
                            <div class="col-7 align-self-center product-availability">
                                <availability :product="product"/>
                            </div>
                            <div class="col-5 px-0 align-self-center product-quantity-selector">
                                <span @click="decreaseProductQuantity">-</span> <input type="number" class="form-control" :placeholder="quantityWithUnit" @change="setProductQuantity"> <span @click="increaseProductQuantity">+</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 text-right product-price">
                        <div class="row h-50 product-remove">
                            <div class="col-12 text-right align-self-start mr-3">
                                <a @click="removeProduct"> <span class="product-remove-button"></span> </a>
                            </div>
                        </div>
                        <div class="row h-50 product-prc">
                            <div class="col-12 align-self-center text-nowrap text-right">
                                <strong v-if="product.is_gift">{{ translations['Free'] }}</strong> <strong
                                v-if="product.is_gift === false">{{ product.formattedPrices.total_wt }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-info" v-if="$root.mobile">
                    <div class="row no-gutters">
                        <div class="col-3 pr-0">
                            <div class="px-2 product-image">
                                <a :href="product.link" :title="product.name"> <img :src="product.thumbnail" :alt="product.name"> </a>
                            </div>
                        </div>
                        <div class="col-auto product-title-info">
                            <div class="row">
                                <div class="col product-title">
                                    <a :href="product.link" :title="product.name"> <span>{{ product.name }}</span> </a>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col product-variant">
                                    {{ product.attributes }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col align-self-center product-availability">
                                    <availability :product="product"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row no-gutters product-price mt-3">
                        <div class="col-5 align-self-center product-quantity-selector">
                            <span @click="decreaseProductQuantity">-</span> <input type="number" class="form-control" :placeholder="quantityWithUnit" @change="setProductQuantity"> <span @click="increaseProductQuantity">+</span>
                        </div>
                        <div class="col-5 align-self-center text-nowrap text-right">
                            <strong v-if="product.is_gift">{{ translations['Free'] }}</strong> <strong v-if="product.is_gift === false">{{ product.formattedPrices.total_wt }}</strong>
                        </div>
                        <div class="col-2 text-right align-self-center pr-0">
                            <a @click="removeProduct"> <span class="product-remove-button"></span> </a>
                        </div>
                    </div>
                </div>
                <div class="product-extra" v-if="product.extra === true">
                    {{ translations['Product is available only in Prague store and as such can be only picked up personally. It cannot be combined with other products available in e-shop.'] }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import Availability from "./Availability";

    export default {
        components: {Availability},
        props: ['product'],
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
            quantityWithUnit: function () {
                if (this.product.cart_quantity == 1) {
                    return this.product.cart_quantity + ' ' + this.translations['pc'];
                } else {
                    return this.product.cart_quantity + ' ' + this.translations['pcs'];
                }
            },
        },
        methods: {
            removeProduct: function () {
                this.$store.dispatch('REMOVE_PRODUCT', this.product);
            },
            setProductQuantity: function (event) {
                let value = event.target.value;
                let product = this.product;
                let quantity = null;

                if (!isNaN(parseFloat(value)) && isFinite(value)) {
                    quantity = value;
                }

                if (quantity !== null) {
                    this.$store.dispatch('SET_PRODUCT_QUANTITY', {product, quantity});
                    event.target.value = '';
                }
            },
            increaseProductQuantity: function () {
                this.$store.dispatch('INCREASE_PRODUCT_QUANTITY', this.product);
            },
            decreaseProductQuantity: function () {
                this.$store.dispatch('DECREASE_PRODUCT_QUANTITY', this.product);
            },
        }
    }
</script>

<style scoped lang="scss">
    .product-row {
        background-color: #ffffff;
        padding: 10px 0;
        margin: 0 18px 4px;

        @media (max-width: 1349px) {
            margin: 0 10px;
        }

        .product-image {
            img {
                width: 120px;
                @media (max-width: 1349px) {
                    width: 100%;
                }
            }
        }

        .product-title-info {
            @media (max-width: 1349px) {
                max-width: 75%;
            }
        }

        .product-title {
            font-size: 21px;
            font-weight: 700;
            text-transform: uppercase;
            @media (max-width: 1349px) {
                font-size: 17px;
            }
        }

        .product-variant {
            font-size: 14px;
        }

        .product-availability {
            img {
                margin-right: 8px;
            }

            span {
                font-size: 16px;
                font-weight: 700;
                color: #6eb540;

                @media (max-width: 1349px) {
                    font-size: 14px;
                }
            }
        }

        .product-quantity-selector {
            input {
                width: 64px;
                display: inline-block;
                color: #999999;
                font-size: 16px;
                font-weight: 300;
                text-align: center;
            }

            span {
                margin: 0 10px;
                font-weight: 700;
                font-size: 19px;
                color: #f1b507;
                cursor: pointer;
                user-select: none
            }
        }

        .product-price {
            font-size: 24px;
            font-weight: 700;

            @media (max-width: 1349px) {
                font-size: 20px;
            }
        }

        .product-remove-button {
            line-height: 0.1;
            cursor: pointer;

            &:after {
                color: #b3b3b3;
                display: block;
                content: "\00d7";
                font-size: 24px;
                font-weight: 100;
                padding-right: 0.5rem;
                @media (max-width: 1349px) {
                    font-size: 32px;
                    font-weight: 500;
                }
            }
        }
    }

    .product-extra {
        padding: 10px;
        margin: 10px 10px 0;
        color: #d92628;
        font-weight: bold;
        font-size: 12px;
        background: rgba(217, 38, 40, 0.15);
        border: 1px solid #d92628;
        border-radius: 5px;
    }

    input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance:textfield;
    }
</style>
